import { SB } from '@play-co/replicant';

export default {
  admin: SB.array(
    SB.object({
      coins: SB.int(),
      freeGems: SB.int(),

      reason: SB.string(),
      claimed: SB.boolean(),

      timestamp: SB.int().min(0),
    }),
  ),
};
